import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import type { SpotlightProps } from './Spotlight.types';
import './spotlight.scss';

const Spotlight = ({ title, text, image, button, step, action, position, align, active }: SpotlightProps) => {
  const [isOpen, setIsOpen] = useState(active);

  useEffect(() => {
    setIsOpen(active)
  }, [active]);

  return (
    <div
      className={
        ['sb-spotlight',
          `sb-spotlight--${position}`,
          `sb-spotlight--${align}`,
          `${isOpen && 'sb-spotlight--open'}`
        ].join(' ')}
      data-testid="sb-spotlight"
    >
      {image && <img
        data-testid="sb-spotlight__img"
        src={image}
        alt=""
      />}
      <div
        className="sb-spotlight__info"
        data-testid="sb-spotlight__info"
      >
        {title &&
          <p
            className="sb-spotlight__info--title"
            data-testid="sb-spotlight__info--title"
          >
            {title}
          </p>
        }
        <p
          className="sb-spotlight__info--text"
          data-testid="sb-spotlight__info--text"
        >
          {text}
        </p>
        <div
          className="sb-spotlight__info--bottom"
          data-testid="sb-spotlight__info--bottom"
        >
          {button}
          <>
            {step ?
              step :
              action && action
            }
          </>
        </div>
      </div >
    </div >
  );
};

Spotlight.propTypes = {
  /**
* title
*/
  title: PropTypes.string,
  /**
* text
*/
  text: PropTypes.string,
  /**
* image
*/
  image: PropTypes.string,
  /**
* button
*/
  button: PropTypes.object,
  /**
* step
*/
  step: PropTypes.string,
  /**
* action
*/
  action: PropTypes.object,
  /**
* active
*/
  active: PropTypes.bool,
  /**
* position of spotlight
*/
  position: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
  /**
* align of spotlight
*/
  align: PropTypes.oneOf(['init', 'middle', 'end']),
};

Spotlight.defaultProps = {
  title: "",
  text: "",
  image: "",
  button: <></>,
  step: "",
  action: <></>,
  active: true,
  position: 'top',
  align: 'middle',
};

export default Spotlight;